module.exports = __webpack_public_path__ + "img/img-1280-720.662eee4c.png";